import useReviewsRedirectStore from '~/modules/reviews/stores/useReviewsRedirectStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviewsRedirect = () => passStoreThroughComposableFactory(useReviewsRedirectStore());

export default useReviewsRedirect;
